import ApiService from './apiService';

export const ObjectiveMediaService = {
  getObjectiveMediaAI: async (data: any): Promise<any> => {
    const response = await ApiService.postAI(`/newlane/v1/objective-media-generator`, data);
    return response.data;
  },
};
